<script>
  import gql from 'graphql-tag'

  export default {
    props: ['gid', "showTipsSwitch"],
    apollo: {
      settings: {
        query: gql`query($gid: ID) {
          merchant(gid: $gid) { merchantUser {settings {pay {allowSmsSignaturePad showTipsForPos}}}}
        }`,
        variables() {
          return {
            gid: this.gid
          }
        },
        update: data => data.merchant.merchantUser.settings.pay
      }
    },
    data() {
      return {
        settings: {}
      }
    },
    methods: {
      switchTip() {
        this.$apollo.mutate({
          // Query
          mutation: gql`mutation ($tipsState: Boolean!, $gid: ID) {
            updateTipsForPos(input: {showTipsForPos: $tipsState, userId: $gid}) {
              paySettings { showTipsForPos }
              errors
            }
          }`,
          // Parameters
          variables: {
            tipsState: !this.settings.showTipsForPos,
            gid: this.gid
          },
        }).then(result => {
          if(result.data.updateTipsForPos.errors.length > 0) {
            this.notifyError(result.data.updateTipsForPos.errors[0])
            this.settings.showTipsForPos = !this.settings.showTipsForPos
          } else {
            this.settings.showTipsForPos = result.data.updateTipsForPos.paySettings.showTipsForPos
            this.notifySuccess("Pay settings successfully updated")
          }
        }, error => {
          this.gqlErrorHandler(error)
          this.settings.showTipsForPos = !this.settings.showTipsForPos
        })
      }
    }
  }
</script>

<template>
  <div>
    <section v-if="showTipsSwitch">
      <div class= "very-close-lines">
        Activate Proof of Service Tips:<br>
        
        <small class="grey-text">Allow payers to add tips on PoS Flow</small>
      </div>
      <!-- Switch -->
      <div class="switch">
        <label>
          Off
          <input type="checkbox" @click='switchTip' v-model='settings.showTipsForPos' :disabled="$apollo.loading">
          <span class="lever"></span>
          On
        </label>
      </div>
    </section>
  </div>
</template>
